import Filter from '../../assets/icons/Filter';
import Search from '../../assets/icons/Search';
import Trash from '../../assets/icons/Trash';
import Copy from '../../assets/icons/Copy';
import AddCircle from '../../assets/icons/AddCircle';

export const FilterIcon = () => <Filter />;
export const AddCircleIcon = () => <AddCircle />;
export const TrashIcon = () => <Trash />;
export const CopyIcon = () => <Copy />;
export const SearchIcon = () => <Search />;
